import React, { useState } from 'react';
import InvoiceTable from './components/InvoiceTable';
import UsageMeter from './components/UsageMeter';
import ClientUpgradeCTA from './components/ClientUpgradeCTA';
import { clientProfile } from '../../mocks/client';
import { openBillingPortal } from '../../lib/api/clients';
import DataModeBadge from '../../components/feedback/DataModeBadge';

function ClientBillingPage() {
  const [portalBusy, setPortalBusy] = useState(false);
  const [portalError, setPortalError] = useState('');

  const openPortal = async () => {
    setPortalBusy(true);
    setPortalError('');
    try {
      await openBillingPortal(clientProfile.id);
    } catch (portalRequestError) {
      setPortalError(portalRequestError.message || 'Could not open the billing portal.');
    } finally {
      setPortalBusy(false);
    }
  };

  return (
    <main className="portal-page">
      <header className="portal-page-head">
        <div>
          <p className="eyebrow">BILLING</p>
          <h1>
            Invoices &amp; usage{' '}
            <DataModeBadge mode="sample" label="Sample data — backend pending" />
          </h1>
          <span>
            {clientProfile.plan} plan · renews {clientProfile.contract.renewsOn}
            {clientProfile.contract.autorenew ? ' (auto-renews)' : ''}
          </span>
        </div>
        <button className="portal-primary-button" disabled={portalBusy} onClick={openPortal} type="button">
          {portalBusy ? 'Opening…' : 'Manage billing'}
        </button>
      </header>

      {portalError && <div className="portal-error" role="alert">{portalError}</div>}

      <div className="portal-columns">
        <div className="portal-col-main">
          <section className="portal-card">
            <div className="portal-card-head">
              <div>
                <h2>Invoices</h2>
                <span>Last 4 billing periods</span>
              </div>
            </div>
            <InvoiceTable />
          </section>
        </div>
        <aside className="portal-col-side">
          <UsageMeter />
          <ClientUpgradeCTA onOpenBillingPortal={openPortal} />
        </aside>
      </div>
    </main>
  );
}

export default ClientBillingPage;
